export default function PageHero() {
    return (
        <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Admin Actions
            </h2>
            <p className="text-lg text-gray-600">
                Choose an action to get started
            </p>
        </div>
    )
}